module.exports = __webpack_public_path__ + "static/media/class_job_007.5742fe36.svg";